<div class="operation-view adminEventCreate">
  <div [@slideContent]="operationContainer.inModal">
    @if (!operation || (sectionsContainers && !sectionsContainers.length)) {
      <div>
        <span>
          {{ 'TRANS__CONTENT__PREPARING' | translate }}
        </span>
      </div>
    }
    @else if (operation && sectionsContainers?.length) {
      <div>
        @if (operationStep.selectors) {
          <div>
            @for (selector of operationStep.selectors; track $index) {
              <div>
                <a
                  class="operation-view__copy-button"
                  (click)="enableSelector(selector)"
                >
                  <i class="icon-copy"></i>

                  <span class="underline">
                    {{ selector.select_button_text | translate }}
                  </span>
                </a>
              </div>
            }
          </div>
        }

        @for (sectionsContainer of sectionsContainers; track $index) {
          <ng-container>
            @if (operationStep.model_prime_fields) {
              <app-edit-prime-fields
                [sectionsContainer]="sectionsContainer"
              ></app-edit-prime-fields>
            }
            @else if (operationStep.is_copy_step && operationStep.operation_step_type === OperationStepType.EDIT_SELECTED_COPY) {
              <app-object-copy
                [sectionsContainer]="sectionsContainer"
                [sourceArtifactId]="operationContainer.currentOperation.$$currentStep.$$sourceArtifactId"
              />
            }
            @else {
              <app-object-edit
                [isLocationOperation]="isLocationOperation"
                [sectionsContainer]="sectionsContainer"
                [sectionsToShow]="operationStep.model_sections"
              ></app-object-edit>
            }

            @if (operationStep.can_add_media) {
              <div class="row">
                <app-media-selectors
                  [object]="sectionsContainer.rootObject"
                  [isDialog]="isDialog"
                  [operationUploadContainer]="operation.$$operationUploadContainer"
                  [annotateDashboardClass]="'annotate-dashboard-admin-event-create'"
                ></app-media-selectors>
              </div>
            }
          </ng-container>
        }
      </div>
    }
  </div>
</div>
